import React from "react";
import Shared02Headings from "../../guestsharedcomponents/Shared02Headings/Shared02Headings";
import ContainerCourses from "./ContainerCourses/ContainerCourses";

const G07Courses = () => {
  return (
    <section className="t-ptb-10 t-overflow-x-hidden">
      <div className="t-container">
        <Shared02Headings
          options={{
            style_render: "992",
            main_container_css: "",
            container_mobile_styles: {
              "max-width": "80rem",
              margin: "0 auto",
            },
            container_desktop_styles: false,
            obj_heading: {
              main_text:
                "Not sure <span class='t-enlace'>where to start?</span> ",
              main_tag_version: "h2",
              main_text_css: "t-h-4",
              heading_mobile_styles: {
                "text-align": "center",
                color: "#fff",
                "font-weight": "700",
                "margin-bottom": "0.5rem",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              heading_desktop_styles: {},
            },
            obj_support_heading: {
              main_text:
                "We’ll guide you to the <span class='t-enlace'>right path</span> automatically",
              main_tag_version: "h3",
              main_text_css: "t-h-1",
              heading_mobile_styles: {
                "text-align": "center",
                color: "#fff",
                "font-weight": "900",
                "margin-bottom": "0.5rem",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              heading_desktop_styles: {},
            },

            obj_divider: {
              divider_mobile_styles: {
                width: "60%",
                background:
                  "linear-gradient(90deg, transparent, #e6c28b, transparent)",
                margin: "0 auto 3rem auto",
              },
              divider_desktop_styles: {},
            },
            obj_paragraph: {
              main_text:
                "From your <span class='t-enlace'>first step</span> to advanced refinement, every path is structured to help you grow with clarity and confidence",
              main_tag_version: "p",
              main_text_css: "",
              paragraph_mobile_styles: {
                color: "#fff",
                "font-size": "1.8rem",
                "margin-bottom": "5rem",
                "text-align": "center",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              paragraph_desktop_styles: false,
            },
            obj_buttons: false,
            heading_version: "heading_01",
          }}
        />
      </div>

      <ContainerCourses />
    </section>
  );
};

export default G07Courses;
